export const getUnlockableRewardsSubtitle = (params: Params) => {
  const {
    availablePoints,
    nextReward,
    unlockableRewardsSubtitleNoPoints,
    unlockableRewardsSubtitleDefault,
    unlockableRewardsSubtitleTooManyPoints,
  } = params;

  if (availablePoints === 0) {
    return unlockableRewardsSubtitleNoPoints;
  }

  if (!nextReward) {
    return unlockableRewardsSubtitleTooManyPoints;
  }

  // A free free entree up to $18 is only 338 pts away!
  const name = nextReward.name;
  const hasFreePrefix = name.startsWith('free ');
  const hasFreePlaceholder = unlockableRewardsSubtitleDefault.includes('free (name)');
  const nameWithoutFree = hasFreePrefix && hasFreePlaceholder ? name.replace('free ', '') : name;

  return unlockableRewardsSubtitleDefault
    .replaceAll('(name)', nameWithoutFree)
    .replaceAll('(points)', nextReward.pointsLeft.toString());
};

// ─── Types ──────────────────────────────────────────────────────────────────

type Params = {
  availablePoints: number;
  nextReward: { name: string; pointsLeft: number } | undefined;
  unlockableRewardsSubtitleNoPoints: string;
  unlockableRewardsSubtitleDefault: string;
  unlockableRewardsSubtitleTooManyPoints: string;
};
